// Uygulama genelinde para/tutar girişleri için güvenli format yardımcıları.
// Yazarken 25000000 -> 25.000.000, küsürat kullanıcı virgül girerse 1.234,56 olur.

export const formatMoneyInput = (value) => {
  if (value === null || value === undefined) return "";

  // Firestore/API numeric values can contain a JavaScript decimal dot
  // (for example 206039.64). While user typing treats "." as a thousands
  // separator, real numeric values must be rendered with Turkish separators:
  // 206039.64 -> 206.039,64.
  if (typeof value === "number") {
    if (!Number.isFinite(value)) return "";
    return value.toLocaleString("tr-TR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 6,
    });
  }

  const raw = String(value).trim();
  if (!raw) return "";

  const negative = raw.startsWith("-");
  const cleaned = raw.replace(/[^0-9.,]/g, "");
  const commaIndex = cleaned.indexOf(",");
  const hasDecimalComma = commaIndex !== -1;

  const integerSource = hasDecimalComma ? cleaned.slice(0, commaIndex) : cleaned;
  const decimalSource = hasDecimalComma ? cleaned.slice(commaIndex + 1) : "";

  const integerDigits = integerSource.replace(/[^0-9]/g, "");
  const decimalDigits = decimalSource.replace(/[^0-9]/g, "").slice(0, 6);

  const formattedInteger = integerDigits
    ? integerDigits.replace(/^0+(?=\d)/, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    : "";

  const sign = negative && (formattedInteger || decimalDigits) ? "-" : "";
  if (hasDecimalComma) return `${sign}${formattedInteger || "0"},${decimalDigits}`;
  return `${sign}${formattedInteger}`;
};

export const parseMoneyInput = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  const normalized = String(value)
    .replace(/\s/g, "")
    .replace(/\./g, "")
    .replace(/,/g, ".")
    .replace(/[^0-9.-]/g, "");
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatMoneyDisplayNumber = (value, fractionDigits = 2) => {
  const n = parseMoneyInput(value);
  return n.toLocaleString("tr-TR", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

export const moneyInputProps = {
  type: "text",
  inputMode: "decimal",
};
